import { useCallback } from 'react';
import { CatchNotFound, createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { NotFoundPage } from '@features/auth/pages/NotFoundPage';
import { SiteLayoutWidget } from '@features/shared/ui/SiteLayout/SiteLayoutWidget';
import { TournamentCardPageWidget } from '@features/tournament/pages/TournamentCardPage/TournamentCardPageWidget';
import { TournamentProvider } from '@features/tournament/providers/TournamentProvider';

const querySchema = z.object({
  resultsTab: z.enum(['table', 'rounds', 'list', 'teams']).catch('table').optional(),
});
type Query = z.infer<typeof querySchema>;

export const Route = createFileRoute('/club/$clubId_/tournament/_video/$tournamentId')({
  component: Page,
  validateSearch: querySchema,
});

function Page() {
  const { clubId, tournamentId } = Route.useParams();
  const { resultsTab = 'table' } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onResultsTabChange = useCallback(
    (resultsTab: Query['resultsTab']) => {
      navigate({
        search: (prev) => ({
          ...prev,
          resultsTab,
        }),
        ignoreBlocker: true,
        replace: true,
      });
    },
    [navigate],
  );

  return (
    <CatchNotFound fallback={() => <NotFoundPage subTitle="Турнир не найден" />}>
      <TournamentProvider clubId={clubId} tournamentId={tournamentId}>
        <SiteLayoutWidget clubId={clubId}>
          <TournamentCardPageWidget
            resultsTab={resultsTab}
            onResultsTabChange={onResultsTabChange}
          />
        </SiteLayoutWidget>
      </TournamentProvider>
    </CatchNotFound>
  );
}
